// src/admin/components/Sidebar.jsx
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const Sidebar = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleLogout = () => {
    logout();
  };

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const links = [
    { to: "/infoplace/dashboard/anketa", icon: "📋", text: "Анкети на вступ" },
    { to: "/infoplace/dashboard/shop", icon: "🛒", text: "Магазин" },
    { to: "/infoplace/dashboard/videos", icon: "🎬", text: "Відео про нас" },
    { to: "/infoplace/dashboard/change-password", icon: "🔒", text: "Безпека" },
    { to: "/infoplace/dashboard/advantages", icon: "🎯", text: "Переваги підрозділу" },
    { to: "/infoplace/dashboard/battle-history", icon: "⚔️", text: "Бойовий шлях полку" },
    { to: "/infoplace/dashboard/info", icon: "🌐", text: "Контакти та соцмережі" },
    { to: "/infoplace/dashboard/how-to-help", icon: "🤝", text: "Як допомогти?" },
    { to: "/infoplace/dashboard/pro-polk", icon: "ℹ️", text: "Про полк" },
    { to: "/infoplace/dashboard/patronat", icon: "📁", text: "Патронат" },
    { to: "/infoplace/dashboard/weekend", icon: "📁", text: "Вікенди" },
    // {
    //   to: "/infoplace/dashboard/change-patronat-password",
    //   icon: "🔒",
    //   text: "Зміна пароля Патронату",
    // },
    // {
    //   to: "/infoplace/dashboard/change-weekend-password",
    //   icon: "🔒",
    //   text: "Зміна пароля Вікенду",
    // },
    // { to: "/infoplace/dashboard/change-email", icon: "🔒", text: "Зміна пошт" },
    // { to: "/infoplace/dashboard/change-patronat-email", icon: "🔒", text: "Зміна пошт Патронату" },
    // { to: "/infoplace/dashboard/change-weekend-email", icon: "🔒", text: "Зміна пошт Вікенду" },

  ];

  return (
    <aside
      style={{
        ...styles.sidebar,
        width: isCollapsed ? "clamp(50px,10vw,50px)" : "250px",
      }}
    >
      <div style={{ ...styles.logoContainer, padding: isCollapsed ? "" : "1.5rem" }}>
        {!isCollapsed && <img src="/assets/icons/210-logo-big-bw.svg" alt="Логотип" style={styles.logo} />}
        <img
          onClick={toggleSidebar}
          src={isCollapsed ? "/assets/icons/menu.svg" : "/assets/icons/close.svg"}
          style={{
            ...styles.toggleButton,
            marginLeft: isCollapsed ? "auto" : "1rem",
            marginRight: isCollapsed ? "auto" : "0",
          }}
        />
      </div>

      <nav>
        <ul style={styles.navList}>
          {links.map(({ to, icon, text }) => (
            <li key={to} style={styles.navItem}>
              <NavLink
                to={to}
                style={({ isActive }) =>
                  isActive
                    ? {
                        ...styles.navLink,
                        ...styles.navLinkActive,
                        justifyContent: isCollapsed ? "center" : "flex-start",
                      }
                    : { ...styles.navLink, justifyContent: isCollapsed ? "center" : "flex-start" }
                }
                title={isCollapsed ? text : undefined}
              >
                <span
                  style={{
                    ...styles.navIcon,
                    marginRight: isCollapsed ? "0" : "1rem",
                  }}
                >
                  {icon}
                </span>
                {!isCollapsed && <span>{text}</span>}
              </NavLink>
            </li>
          ))}
          <div style={styles.bottomContainer}>
            <button
              onClick={handleLogout}
              style={{
                ...styles.logoutButton,
                justifyContent: isCollapsed ? "center" : "flex-start",
              }}
              title={isCollapsed ? "Вийти" : undefined}
            >
              <span
                style={{
                  ...styles.navIcon,
                  marginRight: isCollapsed ? "0" : "1rem",
                }}
              >
                🚪
              </span>
              {!isCollapsed && <span>Вийти</span>}
            </button>
          </div>
        </ul>
      </nav>
    </aside>
  );
};

const styles: Record<string, React.CSSProperties> = {
  sidebar: {
    backgroundColor: "var(--dark-grey)",
    color: "white",
    height: "100vh",
    overflowY: "auto",
    position: "sticky",
    top: 0,
    scrollbarWidth: "none",
    transition: "width 0.3s ease",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    justifyContent: "space-between",
  },
  logo: {
    height: "60px",
  },
  logoText: {
    marginLeft: "1rem",
    fontWeight: 600,
    fontSize: "1.1rem",
  },
  toggleButton: {
    transition: "background-color 0.3s",
    width:"1.5rem",
    height:"1.5rem",
    margin:"1rem auto",
  },
  navList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  navItem: {
    margin: "0.5rem 0",
  },
  navLink: {
    display: "flex",
    alignItems: "center",
    padding: "0.8rem 1.5rem",
    color: "white",
    textDecoration: "none",
    transition: "background-color 0.3s",
  },
  navLinkActive: {
    backgroundColor: "var(--primary-color)",
  },
  navIcon: {
    fontSize: "1.2rem",
    transition: "margin 0.3s ease",
  },
  logoutButton: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "0.8rem 1.5rem",
    background: "none",
    border: "none",
    color: "white",
    cursor: "pointer",
    transition: "background-color 0.3s",
    textAlign: "left",
  },
  bottomContainer: {
    width: "100%",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
  },
};

export default Sidebar;
